<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<section aria-describedby="login-content" aria-labelledby="login-heading" aria-modal="true"
         class="slds-modal slds-fade-in-open"
         role="dialog"
         tabindex="-1">
  <div class="slds-modal__container">
    <header class="slds-modal__header">
      <button class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
              id="login-close" title="Close">
        <acc-icon href="close" size="large"></acc-icon>
      </button>

      <h1 class="slds-text-heading_medium slds-hyphenate"
          id="login-heading">
        <svg aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-light">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#outcome"></use>
        </svg>
        <span [innerHTML]="loginHeading" class="slds-m-left_small"></span>
      </h1>

      <acc-help-button style="position: absolute; right: 1rem; top: 1rem;"
                       title="Login Help">
        <p>Login with your Salesforce user name</p>
        <ul class="slds-list_dotted">
          <li>Click on the Salesforce button, this will redirect to the Salesforce login page</li>
        </ul>
        <p class="slds-m-top_small">Sandbox Login</p>
        <ul class="slds-list_dotted">
          <li>Enter <kbd>test</kbd> in the Auth Server field</li>
          <li>You may have to select <kbd>Re-Authorize</kbd> to switch the Salesforce auth server</li>
          <li>Click on the Salesforce button, this will redirect to the Salesforce sandbox login page</li>
        </ul>
        <p class="slds-m-top_small">Community Login</p>
        <ul class="slds-list_dotted">
          <li>Enter the community url in the Auth Server field</li>
          <li>You may have to select <kbd>Re-Authorize</kbd> to switch the Salesforce auth server</li>
          <li>Click on the Salesforce button, this will redirect to the Community login page</li>
        </ul>
      </acc-help-button>
    </header>

    <div class="slds-modal__content slds-p-horizontal_medium" id="login-content">
      <div class="slds-tabs_default">
        <ul class="slds-tabs_default__nav" role="tablist">
          <li *ngIf="showSalesforce"
              [class.slds-is-active]="tabActive==='sf'"
              class="slds-tabs_default__item"
              role="presentation"
              title="Login via Salesforce">
            <a (click)="onClickSalesforce()"
               [attr.aria-selected]="tabActive==='sf'"
               [tabindex]="tabActive==='sf' ? 0 : -1"
               aria-controls="login-sf"
               class="slds-tabs_default__link"
               id="login-sf__item"
               role="tab">Salesforce
            </a>
          </li>
          <li *ngIf="showGoogle"
              [class.slds-is-active]="tabActive==='google'"
              class="slds-tabs_default__item"
              role="presentation"
              title="Login via Google">
            <a (click)="onClickGoogle()"
               [attr.aria-selected]="tabActive==='google'"
               [tabindex]="tabActive==='google' ? 0 : -1"
               aria-controls="login-google"
               class="slds-tabs_default__link"
               id="login-google__item"
               role="tab">Google
            </a>
          </li>
          <li *ngIf="showManual"
              [class.slds-is-active]="tabActive==='manual'"
              class="slds-tabs_default__item"
              role="presentation"
              title="Manual Login">
            <a (click)="onClickManual()"
               [attr.aria-selected]="tabActive==='manual'"
               [tabindex]="tabActive==='manual' ? 0 : -1"
               aria-controls="login-manual"
               class="slds-tabs_default__link"
               id="login-manual__item"
               role="tab">Manual
            </a>
          </li>
        </ul>

        <div *ngIf="showSalesforce"
             [class.slds-hide]="tabActive!=='sf'"
             [class.slds-show]="tabActive==='sf'"
             aria-labelledby="login-sf__item"
             class="slds-tabs_default__content"
             id="login-sf" role="tabpanel">
          <form [formGroup]="sfForm" class="slds-grid slds-wrap">

            <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-2 slds-align-middle">
              <a [href]="sfUrl"
                 class="slds-button slds-button_neutral slds-text-title_bold"
                 style="padding: .5rem 1.5rem"
                 title="Login via Salesforce"><img alt="Login via Salesforce" src="/assets/images/icons8-salesforce.svg"> Salesforce
              </a>
            </div>

            <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-2">
              <div class="slds-form-element">
                <label class="slds-form-element__label" for="login-sf-auth">Auth Server</label>
                <div class="slds-form-element__control">
                  <input class="slds-input" formControlName="sfAuth" id="login-sf-auth" placeholder="login.salesforce.com"
                         type="text">
                </div>
                <div class="slds-form-element__help">test or myDomain or community server</div>
              </div>
            </div>

            <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-2">
              <div class="slds-form-element">
                <div class="slds-form-element__control">
                  <div class="slds-checkbox">
                    <input formControlName="rememberMe" id="login-sf-rememberMe" name="rememverMe" type="checkbox">
                    <label class="slds-checkbox__label" for="login-sf-rememberMe">
                      <span class="slds-checkbox_faux"></span>
                      <span class="slds-form-element__label">Remember Me</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="slds-col slds-size_1-of-1 slds-small-size_1-of-2">
              <div class="slds-form-element">
                <div class="slds-form-element__control">
                  <div class="slds-checkbox">
                    <input formControlName="reAuthorize" id="login-sf-reAuthorize" name="reAuthorize" type="checkbox">
                    <label class="slds-checkbox__label" for="login-sf-reAuthorize">
                      <span class="slds-checkbox_faux"></span>
                      <span class="slds-form-element__label">Re-Authorize</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>

        <div *ngIf="showGoogle"
             [class.slds-hide]="tabActive!=='google'"
             [class.slds-show]="tabActive==='google'"
             aria-labelledby="login-google__item"
             class="slds-tabs_default__content"
             id="login-google" role="tabpanel">

          <a [href]="googleUrl"
             class="slds-button slds-button_neutral slds-text-title_bold"
             style="padding: .5rem 1.5rem"
             title="Login via Google"><img alt="Login via Google" src="/assets/images/icons8-google.svg"> Google
          </a>

        </div>

        <div *ngIf="showManual"
             [class.slds-hide]="tabActive!=='manual'"
             [class.slds-show]="tabActive==='manual'"
             aria-labelledby="login-manual__item"
             class="slds-tabs_default__content"
             id="login-manual" role="tabpanel">
          <form (ngSubmit)="onSubmitManual()" [formGroup]="manualForm">

            <div class="slds-form-element">
              <label class="slds-form-element__label" for="login-manual-un">User Name</label>
              <div class="slds-form-element__control">
                <input autocomplete="username"
                       class="slds-input" formControlName="un" id="login-manual-un" type="text">
              </div>
            </div>

            <div class="slds-form-element">
              <label class="slds-form-element__label" for="login-manual-pw">Password</label>
              <div class="slds-form-element__control">
                <input autocomplete="current-password"
                       class="slds-input" formControlName="pw" id="login-manual-pw" type="password">
              </div>
            </div>

            <div class="slds-form-element slds-m-vertical_medium">
              <div class="slds-form-element__control">
                <div class="slds-checkbox">
                  <input formControlName="rememberMe" id="login-manual-rememberMe" name="rememberMe" type="checkbox">
                  <label class="slds-checkbox__label" for="login-manual-rememberMe">
                    <span class="slds-checkbox_faux"></span>
                    <span class="slds-form-element__label">Remember Me</span>
                  </label>
                </div>
              </div>
            </div>

            <button class="slds-button slds-button_neutral" id="login-manual-reset" type="reset">Reset</button>
            <button [disabled]="!manualForm.valid"
                    class="slds-button slds-button_brand"
                    id="login-manual-submit">Login
            </button>
          </form>
        </div>

      </div>
    </div>

    <footer class="slds-modal__footer slds-modal__footer_directional">
      <acc-status-line [message]="status" id="loginStatus"></acc-status-line>
    </footer>

    <aside class="slds-card slds-m-top_small slds-p-around_medium slds-scrollable"
           style="background: #d8edff; max-height: 30%;">
      <ng-content></ng-content>
    </aside>
  </div>
</section>
<div class="slds-backdrop slds-backdrop_open"></div>
